import fileDownload from "js-file-download";
import { APICall } from "../API/APICalls";
import moment from "moment";
import notify from "../../ReusableComponents/ToastNotification/ToastNotification";

export const excelDownloadCommon=async (apiUrl,payload,filename,setLoader)=>{
  const fileExtension = ".xlsx";
  setLoader(true)
        try {
              let res = await APICall(apiUrl, payload, "POST");     
              console.log(`${filename} excel response`,res);
          // if(filename=="Badge-Master-"||filename=="knowledge-base-Master-"||filename=="Useful-Link-Master-"||filename=="Event-Gallery-Master-"){
          //   if (res.data.result !== null && res.data.bufferData.type === "Buffer") {
          //     let byteArray = new Uint8Array(res.data.result);
          //     fileDownload(
          //       byteArray,
          //       filename +
          //       `${moment(new Date()).format("DD MMM YYYY")}${fileExtension}`
          //     ); //add time stamp
          //   } else {
          //     notify(1, "Export Failed.");
          //   }
          // }  else{
            if (res.data !== null && res.data.type === "Buffer") {
              let byteArray = new Uint8Array(res.data.data);
              fileDownload(
                byteArray,
                filename +
                `${moment(new Date()).format("DD MMM YYYY")}${fileExtension}`
              ); //add time stamp
            } else {
              notify(1, "Export Failed.");
            }
          // }    
               
             
        } catch (error) {
          notify(1, "Error");
        }
        setLoader(false)
}